export const EXTERNAL_LINKS = {
  TERMS_OF_USE: 'https://xohealth.com/legal/terms-conditions/',
  PRIVACY_POLICY: 'https://xohealth.com/legal/privacy-policy/',
  ABOUT_XO_HELATH: 'https://xohealth.com/about-us/',
};
